// Shared labels + formatters for the ETT exam-report views — EttReportView (the printable
// report body), the classroom report page, and the prep-program chapter-sessions modal.
// Single source so these don't drift across copies (they previously did: "N/A"/"-" vs
// "—"/"–", and only some handled array answers).

export const TEST_TYPE_LABELS = {
    0: "SAT",
    1: "ACT",
    2: "AP",
    3: "PSAT",
    10: "Weekly SAT",
    11: "Weekly ACT",
    12: "Weekly AP",
    20: "Half SAT",
    21: "Half ACT",
    22: "Half AP",
    23: "Half PSAT",
};

export const OPTION_LETTERS = ["A", "B", "C", "D", "E"];
export const DIFFICULTY_LABELS = { 1: "Easy", 2: "Medium", 3: "Hard" };

// Long form (e.g. "June 23, 2026"); "N/A" when missing. Used in report headers.
export const formatDate = (dateStr) =>
    dateStr
        ? new Date(dateStr).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
        : "N/A";

// Short locale date / datetime; "—" when missing.
export const formatShortDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : "—");
export const formatDateTime = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

// Seconds → "Xm Ys" / "Ys"; "–" when zero/missing.
export const formatTime = (seconds) => {
    if (!seconds) return "–";
    const mins = Math.floor(seconds / 60);
    const secs = Math.round(seconds % 60);
    return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
};

// Option index → letter; arrays → comma-joined; "–" when empty.
export const formatAnswer = (answer, answerType) => {
    if (answer === null || answer === undefined || answer === "") return "–";
    if (Array.isArray(answer)) return answer.map((a) => formatAnswer(a, answerType)).join(", ");
    if (answerType === "option") {
        const idx = parseInt(answer, 10);
        if (!isNaN(idx) && idx >= 0 && idx < OPTION_LETTERS.length) return OPTION_LETTERS[idx];
    }
    return String(answer);
};
